///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////
import { Point3d } from "./Common/Geometry";
import { OdBaseCuttingPlaneDragger } from "./OdBaseCuttingPlaneDragger";

export class OdCuttingPlaneXAxisDragger extends OdBaseCuttingPlaneDragger {
  override createNormal(): number[] {
    return [1, 0, 0];
  }

  override handleDelta(delta: Point3d): Point3d {
    delta.y = 0.0;
    delta.z = 0.0;
    return delta;
  }

  override getPlanePreviewCoordinate(): number[] {
    return [
      this.m_center.x,
      this.m_center.y - this.m_size_y,
      this.m_center.z - this.m_size_z,
      this.m_center.x,
      this.m_center.y + this.m_size_y,
      this.m_center.z - this.m_size_z,
      this.m_center.x,
      this.m_center.y + this.m_size_y,
      this.m_center.z + this.m_size_z,
      this.m_center.x,
      this.m_center.y - this.m_size_y,
      this.m_center.z + this.m_size_z,
    ];
  }
}
